import api from "../services/api";

export const sendEmail = (payload) =>
  api.post("/email/send", payload);
